// removed by extract-text-webpack-plugin
module.exports = {"layout":"layout--1NuH8","content":"content--37dfQ","status1":"status1--3YFdR","status2":"status2--TR-UJ","status3":"status3--2Q_X-","info":"info--LF0TR","code":"code--2iuFM","txt":"txt--1Sk0I"};


//////////////////
// WEBPACK FOOTER
// ./src/app.css
// module id = 14
// module chunks = 4